import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BaasicModal, BaasicButton, BasicInput, BaasicFieldDropdown, Stepper, DatePickerField, NumericInputField } from 'core/components';
import { PreviewLayout, Content, PageFooter } from 'core/layouts';
import { ExistingPatientDataModal } from 'application/facility-order/components';
import { observer } from "mobx-react";
import { FacilityOrderTemplateNewFlowCreate, CreateFacilityOrderTemplateNewPatientNewFlowModal } from "application/facility-order-new-flow/components";

function FacilityOrderTemplateNewFlowPatientCreateTemplate({ facilityOrderTemplateNewFlowPatientCreateViewStore, t }) {
    const {
        form,
        stepperStore,
        contentLoading,
        rootStore,
        existingPatientDataModal,
        isCheckingForExistingPatientOver,
        checkForSsn,
        goToNextStep,
        goToPreviousStep,
        titleData,
        createFacilityOrderTemplateNewPatientNewFlowModal
    } = facilityOrderTemplateNewFlowPatientCreateViewStore;

    return (
        <PreviewLayout className="container container--new-flow container--footer-bottom is-nested" store={facilityOrderTemplateNewFlowPatientCreateViewStore}>
            <div className="u-mar--y--lrg">
                <h1>{titleData}</h1>
            </div>
            <div className="u-mar--bottom--lrg">
                <Stepper store={stepperStore} />
            </div>
            <Content loading={contentLoading}>
                <div className="card card--outlined card--med">
                    <PersonalDataTemplate facilityOrderTemplateNewFlowPatientCreateViewStore={facilityOrderTemplateNewFlowPatientCreateViewStore} />
                </div>
            </Content>
            <PageFooter>
                <BaasicButton
                    className='btn btn--base btn--ghost u-align--h--left u-mar--left--xlrg'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => rootStore.routerStore.goBack()}
                />
                {(stepperStore.currentStep === 2 || stepperStore.currentStep === 3) &&
                    <BaasicButton
                        className="btn btn--base btn--ghost"
                        label="Back"
                        onClick={goToPreviousStep}
                    />
                }
                {!stepperStore.isLastStep && isCheckingForExistingPatientOver &&
                    (stepperStore.currentStep === 1 ?
                        <BaasicButton
                            className="btn btn--base btn--primary u-mar--right--xlrg"
                            label="Next"
                            onClick={() => checkForSsn()}
                            disabled={!stepperStore.isCurrentStepValid}
                        />
                        :
                        <BaasicButton
                            className="btn btn--base btn--primary u-mar--right--xlrg"
                            label="Next"
                            onClick={() => goToNextStep()}
                            disabled={!stepperStore.isCurrentStepValid}
                        />
                    )
                }
                {stepperStore.isLastStep &&
                    <BaasicFormControls
                        className="u-mar--right--xlrg btn btn--base btn--primary"
                        form={form}
                        onSubmit={form.onSubmit}
                        disabled={!stepperStore.isCurrentStepValid}
                    />
                }
            </PageFooter>

            <BaasicModal modalParams={existingPatientDataModal} className="modal__content modal--med">
                <ExistingPatientDataModal />
            </BaasicModal>
            <BaasicModal modalParams={createFacilityOrderTemplateNewPatientNewFlowModal} className="modal__content modal--sml">
                <CreateFacilityOrderTemplateNewPatientNewFlowModal />
            </BaasicModal>
        </PreviewLayout>
    )
}

FacilityOrderTemplateNewFlowPatientCreateTemplate.propTypes = {
    facilityOrderTemplateNewFlowPatientCreateViewStore: PropTypes.object,
    t: PropTypes.func
};

const PersonalDataTemplate = observer(({ facilityOrderTemplateNewFlowPatientCreateViewStore }) => {
    const {
        form,
        stepperStore,
        isCheckingForExistingPatient,
        checkForExistingBrightreePatient,
        contactRelationshipStore,
        stateStore,
        genderStore,
        doctorStore,
        facilityOrderTemplateNewFlowCreateViewStore,
        eligibilityStatusStore,
        eligibilityStatus,
        usIntakeStatus,
        clinicalReviewStatus,
        disabled
    } = facilityOrderTemplateNewFlowPatientCreateViewStore;
    return (

        <React.Fragment>
            {
                stepperStore.currentStep === 0 &&
                <React.Fragment>
                    <h4 className="form__title">Personal Data</h4>
                    <div className="row row--form">
                        <div className="form__group col col-lrg-6 ">
                            <BasicInput field={form.$('firstName')} />
                        </div>
                        <div className="form__group col col-lrg-6 ">
                            <BasicInput field={form.$('lastName')} />
                        </div>
                        <div className="form__group col col-lrg-6 ">
                            <DatePickerField field={form.$('dateOfBirth')} customFormat={"MM/dd/yyyy"} formatPlaceholder={{ year: "yyyy", month: "mm", day: "dd" }} />
                        </div>
                    </div>
                    <div className="type--right">
                        <BaasicButton
                            className="btn btn--base btn--primary"
                            label="Check For Existing"
                            onClick={() => { checkForExistingBrightreePatient() }}
                            icon={
                                isCheckingForExistingPatient
                                    ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                    : 'u-display--none'
                            }
                            disabled={isCheckingForExistingPatient}
                        />
                    </div>
                </React.Fragment>
            }
            {
                stepperStore.currentStep === 1 &&
                <div className="col col-lrg-12">
                    <h4 className="form__title">Personal Data</h4>
                    <div className="row row--form">
                        <div className="form__group col col-lrg-6">
                            <BasicInput field={form.$('ssn')} />
                        </div>
                    </div>
                    <h4 className="form__title">Contact Info</h4>
                    <div className="row row--form">
                        <div className="form__group col col-lrg-6">
                            <BaasicFieldDropdown field={form.$('contactRelationship')} store={contactRelationshipStore} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <BasicInput field={form.$('contactPhone')} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <BasicInput field={form.$('contactFirstName')} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <BasicInput field={form.$('contactLastName')} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <BasicInput field={form.$('contactAddressLine1')} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <BasicInput field={form.$('contactAddressLine2')} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <BasicInput field={form.$('contactCity')} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <BasicInput field={form.$('contactCountry')} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <BaasicFieldDropdown field={form.$('contactState')} store={stateStore} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <BasicInput field={form.$('contactPostalCode')} />
                        </div>
                    </div>
                </div>
            }
            {
                stepperStore.currentStep === 2 &&
                <div className="col col-lrg-12">
                    <h4 className="form__title">Clinical Data</h4>
                    <div className="row row--form">
                        <div className="form__group col col-lrg-6">
                            <BaasicFieldDropdown field={form.$('gender')} store={genderStore} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <NumericInputField field={form.$('height')} setDefaultType={true} showSpinners={false}/>
                        </div>
                        <div className="form__group col col-lrg-6">
                            <BaasicFieldDropdown field={form.$('doc')} store={doctorStore} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <NumericInputField field={form.$('weight')} setDefaultType={true} showSpinners={false}/>
                        </div>
                    </div>
                </div>
            }
            {
                stepperStore.currentStep === 3 &&
                <React.Fragment>
                    <div className="col col-lrg-12">
                        <h4 className="form__title">Template</h4>
                        <div className="modal__body">
                            <FacilityOrderTemplateNewFlowCreate
                                facilityOrderTemplateNewFlowCreateViewStore={facilityOrderTemplateNewFlowCreateViewStore} disabled={disabled}
                            />
                            {!!(usIntakeStatus && usIntakeStatus.completedOn || clinicalReviewStatus && clinicalReviewStatus.startedOn) &&
                                <React.Fragment>
                                    <div className="row u-mar--tom--sml">
                                        <div className="form__group col col-lrg-3">
                                            <BaasicFieldDropdown field={form.$('eligibilityStatusId')} store={eligibilityStatusStore} />
                                        </div>
                                    </div>
                                    {eligibilityStatus &&
                                        <div className="u-flex--default u-mar--bottom--sml">
                                            <label className="type--sml type--color--opaque u-mar--right--tny">After creation, the template will be shown on the Intake Reviewed tab on the US Intake page, and on the {eligibilityStatus == "Eligible" ? "In Progress" : "Reviewed-Clinical"} tab on the Clinical Review page.</label>
                                        </div>
                                    }
                                </React.Fragment>
                            }
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    );
});

PersonalDataTemplate.propTypes = {
    facilityOrderTemplateNewFlowPatientCreateViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(FacilityOrderTemplateNewFlowPatientCreateTemplate);
